import { DeepPartial } from "@/core/utils";

export interface EditableList<T> {
    activeIdx: number|null,
    activeItem: DeepPartial<T>|null,
    errors: string[],
    add: ()=>void,
    remove: (idx: number)=>void,
    edit: (idx: number)=>void,
    onEditComplete: ()=>void
}

export function useEditableList<T>(getItems: ()=>DeepPartial<T>[], createItem: ()=>DeepPartial<T>, validateItem: (item: DeepPartial<T>) => string[], onChange: ()=>any): EditableList<T> {
    return {
        activeIdx: null,
        activeItem: null,
        errors: [],
        add: function() {
            this.activeIdx = getItems().length;
            this.activeItem = createItem();
            this.errors = [];
        },
        remove: function(idx: number) {
            getItems().splice(idx,1);
            onChange();
        },
        edit: function(idx: number) {
            this.activeIdx = idx;
            this.activeItem = {...getItems()[idx]};
            this.errors = [];
        },
        onEditComplete: function() {
            this.errors = validateItem(this.activeItem!);
            if (this.errors.length == 0) {
                getItems()[this.activeIdx!] = this.activeItem as DeepPartial<T>;
                this.activeIdx = null;
                this.activeItem = null;
                this.errors = [];
                onChange();
            }
        },
    }
}